
import { Component, Mixins } from 'vue-property-decorator';
import HomeFavoritelist from './';
import HomeFavoritelistItem from './HomeFavoritelistItem/HomeFavoritelistItem.vue';
const Words: Dictionary = {
  title01: `<span class="en">FAVORITE LIST</span><span class="ja">お気に入り</span>`,
  close: '閉じる',
  link: {
    open: '全て表示する',
    edit: '編集',
  },
  btMoreSp: 'お気に入りを全て表示する',
};
@Component({
  components: {
    HomeFavoritelistItem,
  },
})
export default class HomeFavoritelistJa extends Mixins(HomeFavoritelist) {
  private words = Words;
}
